import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  colors, SovosRaisedButton, SovosFlatButton
} from 's1-ui';
import TextField from 'commonComponents/textField';
import logo from 'resources/common-white-sovos-shipcompliant-logo.svg';

const { primaryNavy, neutralWhite, buttonOrange } = colors;

const styles = {
  pageContainer: {
    backgroundColor: primaryNavy,
    position: 'fixed',
    overflowY: 'auto',
    height: 'calc(100vh - 30px)',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexFlow: 'column nowrap',
  },
  loginText: {
    marginTop: 60,
    color: neutralWhite,
    fontSize: 35,
    fontWeight: 100
  },
  loginButton: {
    marginTop: 80
  },
  signUp: {
    marginTop: 20,
    display: 'flex',
    alignItems: 'center'
  },
  signUpLabel: {
    color: neutralWhite,
    fontWeight: 300
  },
  signUpButton: {
    fontSize: 18
  },
  passwordReset: {
    marginTop: 20,
    display: 'flex',
    alignItems: 'center'
  },
  passwordResetLabel: {
    color: neutralWhite,
    fontWeight: 300
  },
  passwordResetButton: {
    fontSize: 18
  },
  flatButton: {
    'button&:not(.another):not(.annoying):not(.specificity):not(.contest)': {
      padding: 0,
      textTransform: 'none'
    }
  },
  passwordResetSnackbar: {
    position: 'absolute'
  },
};

// eslint-disable-next-line arrow-body-style
const getOnChange = (parentValue, parentOnChange, key) => {
  return function onChange(newValue) {
    parentOnChange({ ...parentValue, [key]: newValue });
  };
};

const InputField = ({
  value, onChange, label, style, error, className, type, onKeyDown
}) => {
  const errorBool = error !== undefined;
  return (
    <div style={ { paddingTop: 30 } }>
      <TextField
        InputProps={ {
          placeholder: label,
          error: errorBool
        } }
        style={ style }
        label={ label }
        value={ value }
        className={ className }
        onChange={ e => onChange(e.target.value) }
        onKeyDown={ onKeyDown }
        type={ type }
      />
    </div>
  );
};

InputField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  style: PropTypes.object.isRequired,
  error: PropTypes.string,
  onKeyDown: PropTypes.func.isRequired,
  className: PropTypes.string,
  type: PropTypes.string
};

InputField.defaultProps = {
  value: '',
  className: undefined,
  error: undefined,
  type: undefined,
};


export const UnstyledLoginDisplay = ({
  classes, value, onChange, errors, onSubmit, signUpRedirect, onKeyDown, forgotPasswordRedirect
}) => (
  <div className={ `CCP__Login__Container ${classes.pageContainer}` }>
    <div>
      <img
        src={ logo }
        alt="shipcompliant_logo"
        height="50"
      />
    </div>
    <div className={ classes.loginText }>
      Login to ShipCompliant Carrier Compliance
    </div>
    <div className={ classes.formContainer }>
      <InputField
        value={ value.Email }
        className="CCP_LOGIN_USERNAME_INPUT"
        onChange={ getOnChange(value, onChange, 'Email') }
        onKeyDown={ onKeyDown }
        label="Email"
        error={ errors.Email }
        style={ { width: 350 } }
      />
      <InputField
        value={ value.Password }
        className="CCP_LOGIN_PASSWORD_INPUT"
        onChange={ getOnChange(value, onChange, 'Password') }
        onKeyDown={ onKeyDown }
        label="Password"
        type="password"
        error={ errors.Password }
        style={ { width: 350 } }
      />
    </div>
    <div className={ classes.loginButton }>
      <SovosRaisedButton
        className="CCP_LOGIN_SUBMIT_BUTTON"
        color={ neutralWhite }
        backgroundColor={ buttonOrange }
        onClick={ onSubmit }
      >
        <span style={ { fontWeight: 300 } }>LOGIN</span>
      </SovosRaisedButton>
    </div>
    <div className={ classes.signUp }>
      <span className={ classes.signUpLabel }>{ "If you don't already have an account" } - </span>
      <SovosFlatButton
        className={ classes.flatButton }
        color={ buttonOrange }
        onClick={ () => signUpRedirect() }
      >
        <span className={ classes.signUpButton }>Sign Up</span>
      </SovosFlatButton>
    </div>
    <div className={ classes.passwordReset }>
      <span className={ classes.passwordResetLabel }>{ 'If you forgot your password' } - </span>
      <SovosFlatButton
        className={ classes.flatButton }
        color={ buttonOrange }
        onClick={ () => forgotPasswordRedirect() }
      >
        <span className={ classes.passwordResetButton }>Reset Password</span>
      </SovosFlatButton>
    </div>
  </div>
);

UnstyledLoginDisplay.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  signUpRedirect: PropTypes.func.isRequired,
  forgotPasswordRedirect: PropTypes.func.isRequired
};

export default withStyles(styles)(UnstyledLoginDisplay);
